<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <Adminheader></Adminheader>
        <section class="mt-3">
            <mdb-row>
                <mdb-col>
                    <h2>Pré-enregistrements ({{nbusers}})</h2>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <!--Grid column-->
                <mdb-col xl="8" md="12">
                    <mdb-tbl striped>
                        <mdb-tbl-head>
                            <tr>
                                <th>Nom</th>
                                <th>Email</th>
                                <th>Agence</th>
                                <th>&nbsp;</th>
                            </tr>
                        </mdb-tbl-head>
                        <mdb-tbl-body>
                            <tr v-for="user in users" :key="user.id">
                                <td>{{user.fullname}}</td>
                                <td>{{user.email}}</td>
                                <td>{{user.agency}}</td>
                                <td><mdb-btn size="sm" v-on:click="loadUserDetails(user.id)">Détails</mdb-btn></td>
                            </tr>
                        </mdb-tbl-body>
                    </mdb-tbl>
                </mdb-col>
                <mdb-col xl="4" md="4">
                    <usercard type="preregister" :userid="selecteduser"></usercard>
                </mdb-col>

            </mdb-row>
        </section>
        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>
    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import Adminheader from '@/components/Adminheader.vue';
    import {
        mdbContainer,
        mdbFooter,
        mdbCol,
        mdbRow,
        mdbTbl,
        mdbTblHead,
        mdbTblBody,
        mdbBtn,
    } from 'mdbvue';
    import usercard from '../components/usercard.vue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Preregistration',
        components: {
            usercard,
            Vedheader,
            mdbContainer,
            mdbFooter,
            mdbCol,
            mdbRow,
            Adminheader,
            mdbTbl,
            mdbTblHead,
            mdbTblBody,
            mdbBtn,
        },
        data() {
            return {
                users: [],
                isLoading: true,
                selecteduser: null,
                nbusers: 0,
            };
        },
        mounted() {
            this.getAndDisplayPreregistrations();
        },
        methods: {
            getAndDisplayPreregistrations() {
                const api = new Apicall();
                const self = this;
                api.getPreregistrationUsers().then((response) => {
                    if (response.status === 'OK') {
                        self.users = response.users;
                        self.nbusers = self.users.length;
                    }
                });
            },
            loadUserDetails(userid) {
                this.selecteduser = userid;
            },
        },
    };
</script>
